import { Input, Button, Modal, Tooltip, message } from "antd";
import copy from 'copy-to-clipboard';
import { useEffect, useState } from "react";

export function Share({
    onCancel
}){
    const [url, setUrl] = useState("");
    useEffect(() => {
        setUrl(window.location.href);
    }, []);
    return <Modal title="Share" visible={true} footer={null} onCancel={onCancel}>
        <label>Copy the below link to share</label>
        <Input.Group style={{ width: '100%' }}>
            <Input style={{ width: 'calc(100% - 70px)' }} defaultValue="https://ant.design" value={url} />
            <Tooltip title="Copy URL">
                <Button type="primary" onClick={() => {
                    copy(window.location.href, {
                        debug: true,
                        message: 'Press #{key} to copy',
                    });
                    message.success("Copied to clipboard", 2);
                }}>Copy</Button>
            </Tooltip>
        </Input.Group>
    </Modal>
}